
import NavBar from '../../components/feature/NavBar';
import Partnership from '../home/components/Partnership';
import PartnershipForm from '../home/components/PartnershipForm';
import SEOHead from '../../components/feature/SEOHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://zjfitservices.com';

const partnershipJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'MSP Partnership Program | ZJF IT Services LLC',
    description: 'Partner with ZJF IT Services LLC for white-label IT field execution. Reliable, scalable deployment support for MSPs and IT integrators across New York and nationwide.',
    url: `${siteUrl}/partnership`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: 'Partnership', item: `${siteUrl}/partnership` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'MSP White-Label IT Field Services Partnership',
    provider: {
      '@type': 'LocalBusiness',
      name: 'ZJF IT Services LLC',
      url: siteUrl,
    },
    description: 'White-label field execution for MSPs and IT integrators — reliable, fast, and nationwide IT deployment support.',
    areaServed: { '@type': 'Country', name: 'United States' },
  },
];

export default function PartnershipPage() {
  return (
    <div className="min-h-screen bg-zinc-950">
      <SEOHead
        title="MSP Partnership Program | ZJF IT Services LLC"
        description="Partner with ZJF IT Services LLC for white-label IT field execution. Reliable, scalable deployment support for MSPs and IT integrators across New York and nationwide."
        keywords="MSP partnership IT services, white-label IT deployment, IT integrator partner New York, field services MSP, outsourced IT deployment"
        canonical={`${siteUrl}/partnership`}
        jsonLd={partnershipJsonLd}
      />
      <NavBar />
      <div className="pt-20">
        <div className="py-16 bg-zinc-950 text-center border-b border-zinc-800">
          <span className="text-orange-500 text-sm font-semibold uppercase tracking-widest mb-3 block">MSP Partnership Program</span>
          <h1 className="text-5xl font-bold text-white mb-4">Partner With ZJF IT Services</h1>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            White-label field execution for MSPs and IT integrators — reliable, fast, and nationwide.
          </p>
        </div>
        <Partnership />
        <PartnershipForm />
      </div>
    </div>
  );
}
